import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ebbce0c6&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebbce0c6')) {
      api.createRecord('ebbce0c6', component.options)
    } else {
      api.reload('ebbce0c6', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ebbce0c6&", function () {
      api.rerender('ebbce0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I1iWLw9P1ob4/JS/offershelp.vue"
export default component.exports